import './reset.scss'
import './index.scss'

import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'

import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import App from './app'
import {store, persistor} from './app/redux'

if (process.env.REACT_APP_ENV === 'prod') {
  const tagManagerArgs = {
    gtmId: 'GTM-59C7QRC',
  }
  TagManager.initialize(tagManagerArgs)
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
)
